import { render } from "./nft-collection.vue?vue&type=template&id=5f039f5d"
import script from "./nft-collection.vue?vue&type=script&lang=js"
export * from "./nft-collection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__